/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "capital": {
        "nested": {
          "plan": {
            "nested": {
              "models": {
                "nested": {
                  "Plan": {
                    "nested": {
                      "Status": {
                        "values": {
                          "S_DO_NOT_USE": 0,
                          "PENDING": 1,
                          "ORIGINATED": 2,
                          "ALLOCATED": 3,
                          "CHARGED_OFF": 4,
                          "CLOSED": 10,
                          "CANCELED": 11,
                          "RENEWED": 12,
                          "PREPAID": 13,
                          "BREACHED": 14,
                          "WRITTEN_OFF": 15,
                          "CANCEL_PENDING": 16,
                          "TRANSFERRED": 17,
                          "DECLINED": 18
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.capital?.nested?.plan?.nested?.models?.nested?.Plan?.nested?.Status) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Plan @ squareup/capital/plan/models.proto at 195:1
 */
export const Plan = {};
/**
 * SOURCE Status @ squareup/capital/plan/models.proto at 196:3
 */
Plan.Status = $root.lookupEnum('squareup.capital.plan.models.Plan.Status').values;